<template>
  <div>
    <tab ref="tab" :tab-list="tabList" class="tab-list" />

    <section class="news-title-wrap">
      <h4 class="news-title">{{ $t('menuNewsroom.release') }}</h4>
      <div class="news-title-sub">{{ $t('release.title') }}</div>
    </section>

    <list-component
      type="media"
      date="ReportDay"
      page-query="page"
      :size="listSize"
    />
  </div>
</template>
<script>
import listPosition from '@/mixins/listPostion'

export default {
  components: {
    tab: () => import('@/components/base/Tab'),
    listComponent: () => import('@/components/base/NewsroomList'),
  },
  mixins: [listPosition],
  props: {
    tabList: {
      type: Array,
      default: function () {
        return {
          name: String,
          path: String
        }
      }
    },
    listSize: {
      type: Number,
      default: 10
    }
  }
}
</script>
